import {
  FETCH_SCHOOL_CLASSES,
  GET_AND_UPDATE_REQUESTS,
  REFRESH_WONDE_SCHOOLS,
  REQUEST_ACCESS,
  START_SCHOOL_SYNC_MUTATION,
} from "./Mutations";
import { GET_WONDE_SYNC_FOR_SCHOOL, GET_WONDE_SYNC_REQUESTS } from "./Queries";

export class WondeClient {
  constructor(client) {
    this.client = client;
  }
  async requestWondeAccess({ school, domains, subscriptionType, contacts }) {
    const res = await this.client.mutate({
      mutation: REQUEST_ACCESS,
      variables: {
        school,
        domains,
        subscriptionType,
        contacts,
      },
    });

    return res.data.requestWondeAccess;
  }

  async getAndUpdateRequests({ refresh }) {
    const res = await this.client.mutate({
      mutation: GET_AND_UPDATE_REQUESTS,
      variables: { refresh },
    });
    return res.data.syncRequests;
  }
  async refreshWondeSchools() {
    const res = await this.client.mutate({
      mutation: REFRESH_WONDE_SCHOOLS,
    });
    return res.data.refreshWondeSchools;
  }
  async getWondeSyncRequests({ status, search, first = 20, after = null }) {
    const res = await this.client.query({
      query: GET_WONDE_SYNC_REQUESTS,
      variables: { status, search, first, after },
      fetchPolicy: "network-only",
    });
    return res.data;
  }
  async startSchoolSync({ school }) {
    const res = await this.client.mutate({
      mutation: START_SCHOOL_SYNC_MUTATION,
      variables: { school },
    });
    return res.data.schoolSyncStarted;
  }

  async fetchSchoolClasses({ school }) {
    const res = await this.client.mutate({
      mutation: FETCH_SCHOOL_CLASSES,
      variables: { school },
    });
    return res.data.fetchSchoolClasses;
  }

  async getWondeSync({ wondeSync }) {
    const res = await this.client.query({
      query: GET_WONDE_SYNC_FOR_SCHOOL,
      variables: { wondeSync: wondeSync },
      fetchPolicy: "network-only",
    });
    return res.data;
  }

  pollWondeSync({
    wondeSync,
    school,
    pollInterval = 5000,
    onUpdate = () => {},
  }) {
    return this.client
      .watchQuery({
        query: GET_WONDE_SYNC_FOR_SCHOOL,
        variables: { wondeSync: wondeSync, school: school },
        pollInterval,
        fetchPolicy: "network-only",
      })
      .subscribe({
        next: ({ data }) => onUpdate(data),
        error: (error) => console.error("Polling error:", error),
      });
  }
}
